export default __webpack_public_path__ + "static/media/ConversionTableImg.cffd7223.jpg";